module.exports = __webpack_public_path__ + "static/media/pricing.dafefbb5.png";